import React, { useState } from 'react';
import { requestPortalLink } from '../../api/draftOrders';

import { PiWarningCircleThin } from "react-icons/pi";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";

export function isExpiredPortalTokenError(message) {
  if (!message || typeof message !== 'string') return false;
  return message.toLowerCase().includes('expired');
}

export default function RequestPortalLink({ expiredToken, draftOrderId }) {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [submitError, setSubmitError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimmed = email.trim();
    if (!trimmed || !trimmed.includes('@')) {
      setSubmitError('Please enter a valid email address.');
      return;
    }

    setSubmitError(null);
    setSubmitting(true);
    try {
      await requestPortalLink(trimmed, { expiredToken, draftOrderId });
      setSubmitted(true);
    } catch (err) {
      setSubmitError(err.message || 'Something went wrong. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  if (submitted) {
    return (
      <div className="error">
        <div className="error-icon no-margin-bottom">
          <IoMdCheckmarkCircleOutline className="error-icon-request" />
        </div>
        <h2 className="heading heading--h2">Request Submitted</h2>
        <p>Your request has been submitted. Our team will send you a new link shortly.</p>
      </div>
    );
  }

  return (
    <div className="error">
      <div className="error-icon no-margin-bottom">
        <PiWarningCircleThin className="error-icon-request" />
      </div>
      <h2 className="heading heading--h2">Link Expired</h2>
      <p>This link has expired. Enter your email and we&apos;ll send you a new one.</p>

      <form
        className="request-portal-link-form"
        onSubmit={handleSubmit}
        style={{ maxWidth: '24rem', margin: '0 auto', textAlign: 'left' }}
      >
        <div className="form-group form__input-wrapper">
          <label className="form-label" htmlFor="request-portal-email">
            <span className="form-label-span">Email address</span>
            <input
              id="request-portal-email"
              name="email"
              type="email"
              className="form-input form-control"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              required
              autoComplete="email"
              disabled={submitting}
            />
          </label>
        </div>

        {submitError && (
          <p style={{ color: 'var(--error-color, #c00)', marginBottom: '1rem' }}>{submitError}</p>
        )}

        <button
          type="submit"
          className="button button--primary"
          disabled={submitting}
          style={{ width: '100%' }}
        >
          {submitting ? 'Submitting…' : 'Request New Link'}
        </button>
      </form>
    </div>
  );
}
